/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import {IAppStore} from 'store';
import {StoreScreensType, ScreenDataProps} from 'store/reducers/screens';

export const SET_SCREEN_PROPS = 'SET_SCREEN_PROPS' as const;

export const screensSelector = ({screens}: IAppStore): IAppStore['screens'] => screens;

interface ISetScreenProps {
  screen: StoreScreensType;
  data: Partial<ScreenDataProps>;
}
interface ISetScreenPropsAction {
  type: typeof SET_SCREEN_PROPS;
  payload: ISetScreenProps;
}
export const setScreenProps = (payload: ISetScreenProps): ISetScreenPropsAction => ({
  type: SET_SCREEN_PROPS,
  payload
});

export type ScreensActions = ISetScreenPropsAction;